exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mappastudio{height:280px;width:100%}@media screen and (max-width:768px){#mappastudio{height:200px;height:30vh;height:30dvh}#detailStudioModal{max-height:80%;max-height:80vh;max-height:80dvh;overflow:hidden;overflow-y:auto}}", ""]);

// exports
